// Mensaje legible de un error de axios contra inventory-api: según la ruta, el cuerpo trae
// msg, message o details (express-validator). Sin respuesta, se regresa el error tal cual.
export function apiErrorMessage( e ) {
    const data = e && e.response && e.response.data;
    if ( !data ) return e;
    if ( data.details && data.details.length ) return data.details[0].msg;
    return data.msg || data.message || e.message;
}
